import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CommonService {

  public load = true;
  public showLangSpinner = false;
  private API_URL = environment.url;

  constructor(
    public spinner: NgxSpinnerService,
    private httpClient: HttpClient
  ) {}

  loadSpinner() {
    this.spinner.show('loader', {
      bdColor: 'rgba(88 88 88 / 51%)',
      color: '#203a6e',
      type: 'square-jelly-box',
      fullScreen: true,
      size: 'default',
      zIndex: 400,
    });
  }

  hideSpinner() {
    this.spinner.hide('loader');
  }

  searchBy(rute, data): Observable<any> {
    return this.httpClient.post<any>(`${this.API_URL}/search/${rute}`, data)
      .pipe(map(res => res));
  }

  searchTotalFoodsByUsr(): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/search/get_total_foods_by_user`)
      .pipe(map(res => res));
  }

  getAverageQualifyUsrs(find): Observable<any> {
    return this.httpClient.get<any>(`${this.API_URL}/search/average_qualify_by_user/${find}`)
      .pipe(map(res => res));
  }

  // ✅ REPORTE (QUERY PARAMS)
groupPhotoReport(params: any): Observable<any> {
  let httpParams = new HttpParams();

  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined) {
      httpParams = httpParams.set(key, params[key]);
    }
  });

  return this.httpClient.get<any>(
    `${this.API_URL}/food_image/groupPhotoReport`,
    { params: httpParams }
  );
}


// ✅ EXPORT EXCEL (MISMA LÓGICA)
exportGroupPhotoReport(groupId: number, params: any): Observable<Blob> {
  let httpParams = new HttpParams();

  Object.keys(params).forEach(key => {
    if (params[key] !== null && params[key] !== undefined) {
      httpParams = httpParams.set(key, params[key]);
    }
  });

  return this.httpClient.get(
    `${this.API_URL}/food_image/groupPhotoReport/export/${groupId}`,
    { params: httpParams, responseType: 'blob' }
  );
}


}
